import { CSSProperties } from 'react'

export const s = {
  proposalCard: {
    margin: 8,
    width: 'calc(100% / 3 - 16px)',
    cursor: 'default',
    minWidth: 300,
  },
  img: { height: 210, objectFit: 'cover' } as CSSProperties,
  spaceName: {
    fontSize: '16px',
    fontWeight: 600,
    color: '#262626',
  },
  venueName: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#595959',
  },
  labelText: {
    fontSize: '16px',
    fontWeight: 500,
    color: '#262626',
  },
}
